<template>
    <v-footer style="margin-top: 7rem" class="bg-white-soft">
        <object class="wavy-footer" data="/images/footer.svg"></object>
        <v-row class="content d-md-flex d-block">
            <v-col md="4" cols="12" class="d-flex justify-md-center block-container">
                <div class="block-content">
                    <h3 class="block-header ml-1">Services</h3>
                    <v-tooltip location="right" text="👋 Wat leuk dat je interesse toont!" v-slot:activator="{ props }">
                        <v-row class="align-center ga-1">
                            <v-icon icon="arrow_right" class="text-secondary font-weight-black" />
                            <p class="mb-0">
                                <a v-bind="props" href="https://www.mvk-opleiding.nl/mvk" class="font-weight-bold block-text">MVK-Opleidingen</a>
                            </p>
                        </v-row>
                    </v-tooltip>

                    <v-tooltip location="right" text="🙏 Voel je welkom om een kijkje te nemen!" v-slot:activator="{ props }">
                        <v-row class="align-center ga-1">
                            <v-icon icon="arrow_right" class="text-secondary font-weight-black" />
                            <p class="mb-0">
                                <a v-bind="props" href="https://www.klantenportaal.net" class="font-weight-bold block-text">Klantenportaal</a>
                            </p>
                        </v-row>
                    </v-tooltip>
                    <v-tooltip location="right" text="Bezoek onze website" v-slot:activator="{ props }">
                        <v-row class="align-center ga-1">
                            <v-icon icon="public" class="text-secondary mr-1" />
                            <p v-bind="props" class="mb-0">
                                <a href="https://www.tweb.nl" class="font-weight-bold block-text">www.tweb.nl</a>
                            </p>
                        </v-row>
                    </v-tooltip>
                    <v-row class="align-center ga-1">
                        <v-icon icon="policy" class="text-secondary mr-1" />
                        <p class="mb-0">
                            <a href="https://www.tweb.nl/privacybeleid" target="_blank" class="font-weight-bold block-text"> Privacybeleid </a>
                        </p>
                    </v-row>
                    <div class="my-10 mb-10">
                        <p class="font-weight-bold text-white">Credits</p>
                        <v-row class="align-center ga-1">
                            <v-icon icon="arrow_right" class="text-secondary font-weight-black" />
                            <a href="https://storyset.com" target="_blank" class="block-text font-small">Icons by Storyset</a>
                        </v-row>
                    </div>
                </div>
            </v-col>

            <v-col cols="2" class="d-md-flex d-none justify-center align-center">
                <img src="/images/logo-notext.svg" alt="Logo" class="logo" />
            </v-col>

            <v-col md="5" class="d-flex justify-md-center pl-md-15 block-container">
                <div class="block-content d-flex flex-column">
                    <h3 class="block-header">Over ons</h3>
                    <p class="block-text mt-5">
                        Het verzorgen van praktische opleidingen, doorgeven van <span class="font-weight-black">kennis</span> en het geven van
                        <span class="font-weight-black">eerlijke</span> adviezen van <span class="font-weight-black">goede</span> kwaliteit, gericht
                        op <span class="font-weight-black">jouw</span> wensen, eisen en behoeften.
                        <br />
                        <br />
                        Dat is waar 't Web Opleidingen en Adviezen voor staat.
                    </p>
                </div>
            </v-col>
        </v-row>
    </v-footer>
</template>

<style scoped>
footer {
    position: relative;
    width: 100vw;
    padding: 0 22.5% !important;

    @media screen and (max-width: 1600px) {
        background-image: none;
        background: var(--c-main-dark);
        height: auto;
    }

    @media screen and (min-width: 1200px) {
        margin-top: 500px !important;
    }

    @media screen and (max-width: 768px) {
        margin-top: 75px !important;
    }

    .content {
        position: relative;
        right: 5%;
        z-index: 5;
    }
}

.block-text {
    font-weight: 300;
    color: white;
    text-decoration: none;
}

.logo {
    width: 50px;
    height: 175px;
}

.logo {
    width: 100%;
}

.block-container {
    padding-top: 100px;

    @media screen and (max-width: 1200px) {
        padding-top: 50px;
    }
}

.block-header {
    font-weight: 700;
    font-size: 35px;
    margin-top: 30px;
    color: var(--c-white);
    margin-bottom: 15px !important;

    @media screen and (max-width: 1200px) {
        margin-top: 50px;
    }
}

.wavy-footer {
    height: 500px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
}
</style>
